module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/5page2#chap1"
    }
  }, [_vm._v("I The Sunbonnet Myth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/6chap2#chap2"
    }
  }, [_vm._v("II “Peril Lay at Every Hand”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/7chap3#chap3"
    }
  }, [_vm._v("III The Army Girls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/8chap4#chap4"
    }
  }, [_vm._v("IV Beau Sabreur and His Lady Fair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/9chap5#chap5"
    }
  }, [_vm._v("V Some Ladies of Easy Virtue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/10chap6#chap6"
    }
  }, [_vm._v("VI “Many a Weary Mile”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/11chap7#chap7"
    }
  }, [_vm._v("VII A Lodging for the Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/12chap8#chap8"
    }
  }, [_vm._v("VIII Vanity Conquers All")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/13chap9#chap9"
    }
  }, [_vm._v("IX “A Little Light Diversion”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/14chap10#chap10"
    }
  }, [_vm._v("X Pink Tights and Red Velvet Skirts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/15chap11#chap11"
    }
  }, [_vm._v("XI A Home in the West")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/16chap12#chap12"
    }
  }, [_vm._v("XII The Great Female Shortage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/17chap13#chap13"
    }
  }, [_vm._v("XIII Wyoming Tea Party")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/18chap14#chap14"
    }
  }, [_vm._v("XIV Casting Off the Shackles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/19chap15#chap15"
    }
  }, [_vm._v("XV Schoolmarms and Maternal Forces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/20chap16#chap16"
    }
  }, [_vm._v("XVI Male Viewpoint")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/21chap17#chap17"
    }
  }, [_vm._v("Image Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/22chap18#chap18"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/23chap19#chap19"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/24chap20#chap20"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/25biography#biography"
    }
  }, [_vm._v("A Biography of Dee Brown")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a5bb1f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4-TOC.vue
// module id = 72
// module chunks = 0